@let detail = this.detail();

<div
  class="order-card-wrapper"
  [attr.data-cy]="detail.isEvent ? 'assist-order-event-card' : 'assist-order-service-request-card'"
>
  <div class="header">
    <p class="order-name">
      {{ detail.isEvent ? detail.eventTitle : (detail.resourceDisplayNameForApp ?? detail.resourceName) }}
    </p>
    <p class="date">
      <span>{{ (detail.isEvent ? translation.orders.eventStart : translation.orders.created) | transloco }}</span>
      {{ detail.date | dateFormat }} {{ detail.date | timeFormat }}
    </p>
  </div>
  <div class="items-wrapper">
    <ng-container>
      @for (group of detail.groups; track group) {
        <div class="order-item-wrapper">
          <div class="order-item-inner">
            <div class="image-wrapper">
              <img
                [ngStyle]="{
                  'object-position': group.service.imageObjectPosition,
                }"
                [class.!object-cover]="group.service.imagePreferCover"
                [src]="group.service.imageUrl ?? 'assets/images/placeholder-order.svg' | imageHeight: 80"
              />
            </div>
            <p class="order-item-name">
              {{ group.service.name | localizedString }}<br />
              <span class="ammount"> {{ group.count }}x </span>
            </p>
          </div>
        </div>
      }
    </ng-container>
  </div>
  <div class="footer">
    <div class="state-wrapper">
      @if (detail.isEvent) {
        @for (badge of detail.statusBadges; track badge.status) {
          <div class="state" [ngClass]="badge.cssClass" [attr.data-cy]="'assist-order-event-status-' + badge.status">
            <p>{{ badge.text | transloco }}</p>
          </div>
        }
      }
    </div>
    <div class="detail-button" (click)="detailClicked.emit(null)">
      <cue-icon [icon]="cueSearch" />
      <p>DETAIL</p>
    </div>
  </div>
</div>
